module.exports = __webpack_public_path__ + "static/media/Item_Weapon_Mk47Mutant_C.a2cffaeb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/item/Weapon/Main/Item_Weapon_Mk47Mutant_C.png
// module id = ./src/assets/item/Weapon/Main/Item_Weapon_Mk47Mutant_C.png
// module chunks = 0